import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { APP_INITIALIZER, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GraphQLModule } from './graphql.module';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppMaterialComponentsModule } from './app-material-components';
import {  IConfig, NgxMaskDirective, NgxMaskPipe, provideEnvironmentNgxMask, provideNgxMask } from 'ngx-mask';

export function get_environ_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getEnvironSettings();
}

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};
import { 
  ApiService, 
  AppLoadService, 
  CaseApiService, 
  CaseGqlService, 
  ContactUsModule, 
  DialogSolutionDeployingComponent 
} from '@ebb-v2/ebb-integration';
import { ContactUsAppComponent } from './app.component';
import { RouterModule } from '@angular/router';

@NgModule({
  declarations: [
    ContactUsAppComponent, 
    DialogSolutionDeployingComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    HttpClientModule,
    AppMaterialComponentsModule,
    ContactUsModule,
    RouterModule.forRoot([]),
    FormsModule,
    GraphQLModule,
    NgxMaskDirective, NgxMaskPipe
  ],
  providers: [
    ApiService,provideNgxMask(),
    AppLoadService,
    { provide: APP_INITIALIZER, useFactory: get_environ_settings, deps: [AppLoadService], multi: true },
    { provide: CaseApiService, useClass: CaseGqlService }
  ],
  bootstrap: [ContactUsAppComponent]
})
export class ContactUsAppModule {}
